import { actions } from 'react-redux-form';
import { httpPost, httpGet } from '../../../../../utils/api.utils';
import { getRequestUserSessionData as getUserData } from '../../../../../utils/helpers.utils';
import { getAddresses, getUserLocation } from '../../order-request.functions';

import {
    //model
    wirelessReplaceDeviceModel
    //action
    , setUserLocation
    , setAddressOptions
    , setBusinessCaseOptions
    , setCountryOptions
    , setEquipmentOptions
    , setDeviceAccessories
    , setFormSubmitted
    , setSubscriptionDetails
    , setServiceTypeDetails
    , setFormLoading
    , setResetLoading
} from './../../../../../constants/model-reducers/external/request/wireless-request/wireless-replace-device.settings';

export const replaceDeviceModelAInitialState = wirelessReplaceDeviceModel;


const serviceTypeDetailConst = {
    EquipmentInventoryId: 0
    , OrderCost: 0
}

const defaultState = () => ({
    subscription: {}
    , userLocation: {}
    , countryOptions: []
    , addressOptions: []
    , equipmentOptions: []
    , businessCaseOptions: []
    , deviceAccessories: []
    , serviceTypeDetail: { ...serviceTypeDetailConst }
    , formSubmitted: false
    , isResetLoading: false
});

const initialState = defaultState();

export const wirelessReplaceDeviceActions = {

    getReplaceDeviceFormData: () => (dispatch, state) => {
        const { requestTypeId } = state().createRequest;        
        getUserLocation(dispatch, setUserLocation, requestTypeId);
        getCountries(dispatch);
        getBusinessCases(dispatch);        
    }
    , updateSubscriptionDetails: (subscriptionList, circuitCodePropName) => async (dispatch, state) => {
        const { requestData } = state().requestDetail;
        const { wirelessReplaceDeviceFormA } = state().form;
        const userData = getUserData();
        if (requestData.Order.IsRequestedInBehalf) {
            userData.employeeID = requestData.RequestedInBeHalfOf.EmployeeId;
        }

        const url = 'external/autosuggest/getAllDeviceSubscriptionSuggestions/';

        const res = await httpGet(url
            + userData.employeeID + '/'
            + requestData.Order.RequestType.RequestTypeID
            + '?val=' + encodeURIComponent(requestData.Circuit.CircuitCode));

        if (requestData.Circuit.CircuitCode === '') {
            dispatch({ type: setSubscriptionDetails, data: {} });
        } else {
            const obj = res.find(o => o['CircuitCode'] === requestData.Circuit.CircuitCode);
            if (obj != null && parseInt(obj.CircuitId) !== parseInt(wirelessReplaceDeviceFormA.circuitId)) {
                dispatch(actions.change("wirelessReplaceDeviceFormA.circuitCode", requestData.Circuit.CircuitCode));
                dispatch(actions.change('wirelessReplaceDeviceFormA.circuitId', requestData.Circuit.CircuitId));
                dispatch({ type: setSubscriptionDetails, data: obj });
                dispatch({ type: setServiceTypeDetails, data: serviceTypeDetailConst });
            }
        }        
        dispatch(actions.change('wirelessReplaceDeviceFormA.equipmentInventoryId', requestData.Subscription.EquipmentInventoryId));
        dispatch(actions.change('wirelessReplaceDeviceFormA.additionalInformation', requestData.BusinessJustification.AdditionalInformation));
        dispatch(actions.change('wirelessReplaceDeviceFormA.countryCode', requestData.BillingAddress.CountryCode));
        dispatch(actions.change('wirelessReplaceDeviceFormA.phoneCaseAccessory', requestData.Subscription.PhoneCaseAccessory));
        getMobileServiceTypeOptions(dispatch, requestData.Subscription.VendorDetailId, requestData.Subscription.CircuitTypeId, userData.employeeID, requestData.Subscription.SubscriptionDetailDevice != null ? requestData.Subscription.SubscriptionDetailDevice.EquipmentInventoryId : 0);
        getServiceTypeDetails(dispatch, requestData.Subscription.EquipmentInventoryId);
        getAddresses(dispatch, setAddressOptions, requestData.BillingAddress.CountryCode, true);

        if (requestData.BillingAddress.IsOtherLocation === true) {
            dispatch(actions.change('wirelessReplaceDeviceFormA.otherLocationAddressId', requestData.BillingAddress.OtherDeliveryAddressId));
            dispatch(actions.change('wirelessReplaceDeviceFormA.otherLocationAddress', requestData.BillingAddress.OtherDeliveryAddress));
            dispatch(actions.change('wirelessReplaceDeviceFormA.billingLocationAddressId', requestData.BillingAddress.LocationId));
        }
        else {
            dispatch(actions.change('wirelessReplaceDeviceFormA.billingLocationAddressId', requestData.BillingAddress.LocationId))
        }
        dispatch(actions.change('wirelessReplaceDeviceFormA.deliveryAddress', requestData.BillingAddress.DeliveryAddress))
    }
    ,setLoadForm: (isLoad = false) => (dispatch, state) => {
        dispatch({
            type: setFormLoading,
            data: isLoad
        });
    }
    , setRequestorAddress: () => (dispatch, state) => {

        const { showOtherAddress, userLocation } = state().wirelessReplaceDeviceRequest;
        const { requestOnBehalfData } = state().createRequest;

        var location = {
            ...userLocation
        };

        if (requestOnBehalfData.EmployeeId > 0) {
            location = {
                ...requestOnBehalfData.LocationModel
            };
        }

        getAddresses(dispatch, setAddressOptions, userLocation.CountryCode, showOtherAddress);

        dispatch(actions.change('wirelessReplaceDeviceFormA.country', location.CountryName));
        dispatch(actions.change('wirelessReplaceDeviceFormA.countryCode', location.CountryCode));
        dispatch(actions.change('wirelessReplaceDeviceFormA.billingLocationAddressId', location.LocationId));
        dispatch(actions.change('wirelessReplaceDeviceFormA.otherLocationAddress', ''));
        dispatch(actions.change('wirelessReplaceDeviceFormA.deliveryAddress', location.DeliveryAddress));        
    }
    , onCircuitSelect: (value, propsName, objects, index) => (dispatch, state) => {

        const { wirelessReplaceDeviceFormA } = state().form;       
        const { isRequestOnBehalf, requestOnBehalfData } = state().createRequest;
        const userData = getUserData();
        if (isRequestOnBehalf && requestOnBehalfData.EmployeeId > 0) {
            userData.employeeID = requestOnBehalfData.EmployeeId;
        }
        
        dispatch(actions.change('wirelessReplaceDeviceFormA.accessoryDetailsModel', []));
        dispatch(actions.change('wirelessReplaceDeviceFormA.mobileServiceModel', []));
        dispatch(actions.change('wirelessReplaceDeviceFormA.equipmentInventoryId', 0));
        dispatch({ type: setServiceTypeDetails, data: serviceTypeDetailConst });

        if (value === '' || !propsName) {
            dispatch(actions.reset('wirelessReplaceDeviceFormA'));
            dispatch({ type: setSubscriptionDetails, data: {} });
            dispatch({ type: setDeviceAccessories, data: [] });
        } else {
            if(propsName) {
                var obj=null              
                if(objects !== null && objects !== undefined) {
                    if(index !== -1 && index !== undefined && index !== null) {
                        obj=objects[index]
                    }
                    else if(objects.length === 1) {
                        obj=objects.find(o => o[propsName] === value);
                    }
                    else if (objects.length > 1) {
                        obj = objects.find(o => o[propsName] === value);
                    } 
                }
                if (obj != null && parseInt(obj.CircuitId) !== parseInt(wirelessReplaceDeviceFormA.circuitId)) {
                    dispatch(actions.reset('wirelessReplaceDeviceFormA'));
                    dispatch(actions.change('wirelessReplaceDeviceFormA.circuitCode', obj.CircuitCode));
                    dispatch(actions.change('wirelessReplaceDeviceFormA.circuitId', obj.CircuitId));
                    dispatch({ type: setSubscriptionDetails, data: obj });
                    getMobileServiceTypeOptions(dispatch, obj.VendorDetailId, obj.CircuitTypeId, userData.employeeID, obj.DeviceEquipmentId);
                    dispatch({ type: setServiceTypeDetails, data: serviceTypeDetailConst });
                }
            }            
        }
    }
    , onServiceTypeSelect: (model, value) => (dispatch, state) => {

        dispatch(actions.change(model, value));
        dispatch(actions.change('wirelessReplaceDeviceFormA.mobileServiceModel', []));
        dispatch({ type: setServiceTypeDetails, data: serviceTypeDetailConst });
        getServiceTypeDetails(dispatch, value);

    }
    , onAccessorySelect: (e) => async (dispatch, state) => {

        const { deviceAccessories } = state().wirelessReplaceDeviceRequest;
        const { wirelessReplaceDeviceFormA } = state().form;
        const selectedObj = deviceAccessories.find(x => parseInt(x.EquipmentInventoryId) === parseInt(e.target.value));
        const newAccessories = [...wirelessReplaceDeviceFormA.accessoryDetailsModel];

        if (e.target.checked) {
            newAccessories.push(selectedObj);
        } else {

            const indexOfObject = wirelessReplaceDeviceFormA.accessoryDetailsModel.findIndex(o => {
                return parseInt(o.EquipmentInventoryId) === parseInt(e.target.value);
            });

            newAccessories.splice(indexOfObject, 1);
        }

        dispatch(actions.change('wirelessReplaceDeviceFormA.accessoryDetailsModel', newAccessories));
    }
    , onCountrySelect: (model, value) => async (dispatch, state) => {

        const { countryOptions } = state().wirelessReplaceDeviceRequest;

        dispatch(actions.change(model, value));

        const country = countryOptions.find(o => o['Key'] === value)?.Value;
        dispatch(actions.change('wirelessReplaceDeviceFormA.country', country));
        dispatch(actions.change('wirelessReplaceDeviceFormA.billingLocationAddressId', ''));
        dispatch(actions.change('wirelessReplaceDeviceFormA.otherLocationAddress', ''));
        dispatch(actions.change('wirelessReplaceDeviceFormA.deliveryAddress', ''));

        getAddresses(dispatch, setAddressOptions, value, true);

    }
    , onAddressSelect: (model, value) => async (dispatch, state) => {

        const { addressOptions } = state().wirelessReplaceDeviceRequest;

        dispatch(actions.change(model, value));

        const deliveryAddress = addressOptions.length > 0 ? addressOptions.find(r => parseInt(r.Key) === parseInt(value)).Value : '';
        dispatch(actions.change('wirelessReplaceDeviceFormA.deliveryAddress', deliveryAddress));
        dispatch(actions.change('wirelessReplaceDeviceFormA.otherLocationAddress', ''));

    }
    , submitRequest: (isReplaceUpgradeEligible) => async (dispatch, state) => {

        const { wirelessReplaceDeviceFormA } = state().form;
        const { requestTypeId, isRequestOnBehalf, requestOnBehalfData, isUpdateRequest } = state().createRequest;
        const { subscription, serviceTypeDetail } = state().wirelessReplaceDeviceRequest;
        const { requestData } = state().requestDetail;
        const userData = getUserData();

        if (isRequestOnBehalf) {
            userData.requestInBehalfId = requestOnBehalfData.EmployeeId;
            userData.vip = requestOnBehalfData.Vip;
        }

        userData.managerApproverId = isRequestOnBehalf ?
            requestOnBehalfData.CostCodeApproverEmployeeId : sessionStorage.CostCodeAuthorizerID;

        const data = {
            ChangeRequestModel: {
                ...userData
                , ...wirelessReplaceDeviceFormA
                , VendorDetailId: subscription.VendorDetailId
                , RequestTypeId: requestTypeId
                , EquipmentTypeId: wirelessReplaceDeviceFormA.mobileServiceModel[0].EquipmentTypeId
                , FinanceAccountId: wirelessReplaceDeviceFormA.mobileServiceModel[0].FinanceAccountId
                , OrderId: isUpdateRequest ? requestData.Order.OrderId : 0
                , CircuitId: wirelessReplaceDeviceFormA.circuitId
                , AdditionalInformation: wirelessReplaceDeviceFormA.additionalInformation
                , PhoneCaseAccessory: wirelessReplaceDeviceFormA.phoneCaseAccessory               
                , EquipmentInventoryId: wirelessReplaceDeviceFormA.mobileServiceModel[0].EquipmentInventoryId
                , EquipmentInventory: wirelessReplaceDeviceFormA.mobileServiceModel[0].EquipmentModel
                , otherLocationAddress: wirelessReplaceDeviceFormA.otherLocationAddress
                , OrderInfoId: isUpdateRequest ? requestData.OrderInfoId : 0
                , CircuitOrderId: isUpdateRequest ? requestData.CircuitOrderId : 0
                , CountryCode: wirelessReplaceDeviceFormA.countryCode
                , BillingLocationAddressId: wirelessReplaceDeviceFormA.deliveryAddress[0].LocationId
                , IsReplaceUpgradeEligible: isReplaceUpgradeEligible
                , OrderCost: serviceTypeDetail.OrderCost !== undefined || serviceTypeDetail.OrderCost !== null ? serviceTypeDetail.OrderCost : 0.00
            }
            , CountryCode: wirelessReplaceDeviceFormA.countryCode
            , DeliveryAddressID: wirelessReplaceDeviceFormA.billingLocationAddressId
            , NewDeviceTypeId: wirelessReplaceDeviceFormA.equipmentInventoryId
            , IsAmending: isUpdateRequest
        }

        dispatch({ type: setFormSubmitted, data: true });

        const res = await httpPost('external/replaceDevice/submitReplaceDevice', data);

        if (!(res.Success)) {
            dispatch({ type: setFormSubmitted, data: false });
        }

        return res;

    }
    , resetWirelessReplaceDeviceForm: (isResetRequestOnBehalf = false) => (dispatch, state) => {

        const { takeActionCircuitCode } = state().createRequest;
        if((takeActionCircuitCode !== '' && takeActionCircuitCode !== undefined && takeActionCircuitCode !== null) && isResetRequestOnBehalf) {
            dispatch({ type: setResetLoading, data: false });
            return;
        }
        if (isResetRequestOnBehalf) {
            dispatch({ type: setResetLoading, data: true });
            dispatch(actions.reset('wirelessReplaceDeviceFormA.circuitCode'));
            dispatch(actions.reset('wirelessReplaceDeviceFormA.circuitId'));
            dispatch({ type: setSubscriptionDetails, data: {} });

            setTimeout(function () {
                dispatch({ type: setResetLoading, data: false });
            }, 5);
        }
        else if (!isResetRequestOnBehalf) {
            dispatch(actions.reset('wirelessReplaceDeviceFormA'));
            dispatch({ type: setSubscriptionDetails, data: {} });
        }
        dispatch(actions.reset('wirelessReplaceDeviceFormA'));
        dispatch({ type: setFormSubmitted, data: false });
        dispatch({ type: setServiceTypeDetails, data: serviceTypeDetailConst });
        dispatch({ type: setDeviceAccessories, data: [] });
    }

    , checkReplaceUpgradeEligibility: (circuitId) => async (dispatch) => {
        try {
            if(circuitId ){
                const res = await httpPost('external/replaceDevice/checkReplaceUpgradeEligibility/' + circuitId);
                return res;
            }
            else {
                return false;
            }
        } catch (error) {
            return false;
        }
    }
}

async function getCountries(dispatch) {
    const res = await httpPost('external/replaceDevice/getCountriesList');
    if (res != null) {
        dispatch({ type: setCountryOptions, data: res });
    } else {
        dispatch({ type: setCountryOptions, data: { ...defaultState.countryOptions } });
    }
}

async function getMobileServiceTypeOptions(dispatch, vendorId, circuitTypeId, employeeId, equipmentId) {
    const res = await httpGet('external/orderRequest/getAllMobileServiceTypes/' + vendorId + '/' + circuitTypeId + '/' + employeeId + '/' + equipmentId);
    if (res != null) {
        dispatch({ type: setEquipmentOptions, data: res });
    }
    else {
        dispatch({ type: setEquipmentOptions, data: defaultState.equipmentOptions });
    }
}

async function getBusinessCases(dispatch) {
    const res = await httpPost('external/replaceDevice/getBusinessCases');

    if (res != null) {
        dispatch({ type: setBusinessCaseOptions, data: res });
    } else {
        dispatch({ type: setBusinessCaseOptions, data: { ...defaultState.businessCaseOptions } });
    }
}

async function getServiceTypeDetails(dispatch, typeId) {

    const res = await httpGet('external/orderRequest/getMobileServiceTypeDetails/' + typeId);

    if (res != null && res.length > 0) {
        dispatch({ type: setServiceTypeDetails, data: res[0] });
        dispatch(actions.change('wirelessReplaceDeviceFormA.mobileServiceModel', res));
    } else {
        dispatch({ type: setServiceTypeDetails, data: serviceTypeDetailConst });
        dispatch(actions.change('wirelessReplaceDeviceFormA.mobileServiceModel', []));
    }

}

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case setUserLocation:
            return {
                ...state,
                userLocation: action.data
            };
        case setCountryOptions:
            return {
                ...state
                , countryOptions: action.data
            };
        case setAddressOptions:
            return {
                ...state
                , addressOptions: action.data
            };
        case setEquipmentOptions:
            return {
                ...state
                , equipmentOptions: action.data
            };
        case setBusinessCaseOptions:
            return {
                ...state
                , businessCaseOptions: action.data
            };
        //case setDeviceOptions:
        //    return {
        //        ...state,
        //        deviceOptions: action.data
        //    };
        case setDeviceAccessories:
            return {
                ...state,
                deviceAccessories: action.data
            };
        case setSubscriptionDetails:
            return {
                ...state
                , subscription: { ...action.data }
            };
        case setServiceTypeDetails:
            return {
                ...state,
                serviceTypeDetail: action.data
            };
        case setFormSubmitted:
            return {
                ...state
                , formSubmitted: action.data
            };
        case setFormLoading:
            return {
                ...state
                , isFormLoading: action.data
            };
        case setResetLoading:
            return {
                ...state
                , isResetLoading: action.data
            }
        default: return state;
    }
}